import * as React from "react";
import ErrorScreen from "components/common/ErrorScreen";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { ui } from "aaa";

export const CreditCardUpgradeNotPossibleError = () => (
    <ErrorScreen
        useWebVersion
        externalInterfaceStore={externalInterfaceStore}
        title={ui.__("creditCardUpgrade.upgradeNotPossible.title")}
        message={ui.__("creditCardUpgrade.upgradeNotPossible.message")}
        buttonLabelId="common.backToGeorgeGo"
    />
);


// WEBPACK FOOTER //
// ./src/components/creditCardUpgrade/CreditCardUpgradeNotPossibleError.tsx